"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Container_1 = __importDefault(require("@material-ui/core/Container"));
const core_1 = require("@material-ui/core");
const textEN = {
    imprint: "Imprint",
    privacy: "Privacy",
    generalTerminsConditions: "General Terms and Conditions KTR",
    imprintURL: "https://www.ktr.com/en/imprint",
    privacyURL: "https://otools.ktr.com/otools/DataprotectionEN.html",
    generalTerminsConditionsURL: "https://www.ktr.com/en/general-terms-and-conditions-ktr",
};
const textDE = {
    imprint: "Impressum",
    privacy: "Datenschutz",
    generalTerminsConditions: "AGB KTR",
    imprintURL: "https://www.ktr.com/de/impressum",
    privacyURL: "https://otools.ktr.com/otools/DatenschutzDE.html",
    generalTerminsConditionsURL: "https://www.ktr.com/de/agb-ktr",
};
const textFR = {
    imprint: "En tête",
    privacy: "Propriété",
    generalTerminsConditions: "Conditions générales de vente KTR",
    imprintURL: "https://www.ktr.com/fr/en-tete",
    privacyURL: "https://otools.ktr.com/otools/DataprotectionEN.html",
    generalTerminsConditionsURL: "https://www.ktr.com/fr/conditions-generales-de-vente-ktr",
};
let currentText = textEN;
function Footer(props) {
    const matches = core_1.useMediaQuery('(min-width:600px)');
    const theme = core_1.useTheme();
    switch (props.language) {
        case 'de':
            currentText = textDE;
            break;
        case 'en':
            currentText = textEN;
            break;
        case 'fr':
            currentText = textFR;
            break;
        default:
    }
    const useStyle = core_1.makeStyles({
        topDiv: {
            width: "100%",
            height: "24px",
        },
        orangeRow: {
            height: "14px",
            backgroundColor: theme && theme.palette.third ? theme.palette.third.main : null
        },
        orangeBox: {
            backgroundColor: theme && theme.palette.third ? theme.palette.third.main : null,
            height: "15px",
            width: "9%"
        },
        greyBox: {
            backgroundColor: theme && theme.palette.third ? theme.palette.background.default : null,
            height: "15px",
            width: "9%"
        },
        boxBackgroundDark: {
            backgroundColor: theme && theme.palette.third ? theme.palette.primary.main : null,
            minHeight: "80px"
        },
        link: {
            color: theme && theme.palette.third ? theme.palette.third.main : null
        }
    });
    const classes = useStyle();
    return (react_1.default.createElement("footer", null,
        react_1.default.createElement(core_1.Grid, { container: true, style: { marginTop: "20px" } },
            matches ? (react_1.default.createElement(Container_1.default, null,
                react_1.default.createElement(core_1.Grid, { container: true },
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.orangeBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.greyBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.orangeBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.greyBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.orangeBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.greyBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.orangeBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.greyBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.orangeBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.greyBox }),
                    react_1.default.createElement(core_1.Grid, { item: true, className: classes.orangeBox })))) : '',
            react_1.default.createElement(core_1.Grid, { className: classes.orangeRow, item: true, xs: 12 }),
            react_1.default.createElement(core_1.Grid, { className: classes.boxBackgroundDark, item: true, xs: 12 },
                react_1.default.createElement(Container_1.default, { style: { color: '#8F8F8F', height: "100%" } },
                    react_1.default.createElement(core_1.Grid, { style: { height: "100%" }, container: true, alignContent: 'space-around', item: true, xs: 12 },
                        react_1.default.createElement(core_1.Grid, null,
                            "\u00A9 2020 KTR Systems GmbH\u00A0|\u00A0",
                            react_1.default.createElement(core_1.Link, { href: currentText.imprintURL, className: classes.link }, currentText.imprint),
                            "\u00A0|\u00A0",
                            react_1.default.createElement(core_1.Link, { href: currentText.privacyURL, className: classes.link }, currentText.privacy),
                            "\u00A0|\u00A0",
                            react_1.default.createElement(core_1.Link, { href: currentText.generalTerminsConditionsURL, className: classes.link }, currentText.generalTerminsConditions))))))));
}
exports.default = Footer;
//# sourceMappingURL=Footer.js.map